import Param from '../param';
import tabManager from './lowlayer/tab';
import businessTabManager from './lowlayer/businessTab';
import toggleManager from './lowlayer/toggle';

const param = new Param();

export default class lowlayerManager {
    constructor() {

        this.pageID;
        this.tab;
        this.businessTab;
        this.toggle;

     }
    init(pageID, scroll){

        this.pageID = pageID;
        // console.log("hey",param.tabPage,param.tabPage.indexOf(this.pageID),this.pageID);
        // console.log("hey",param.togglePage,param.togglePage.indexOf(this.pageID),this.pageID);
        this.tab = new tabManager();

        if(param.tabPage.indexOf(this.pageID)>=0){
            this.tab.init(pageID);
            if(param.businessTabPage.indexOf(this.pageID)>=0){
                this.businessTab = new businessTabManager();
                this.businessTab.init(scroll);
            }
        }
        if(param.togglePage.indexOf(this.pageID)>=0){
            this.toggle = new toggleManager();
            this.toggle.init(scroll, this.tab);
        }


    }
    render(){

    }
    resize(display){

        if(param.tabPage.indexOf(this.pageID)>=0) this.tab.resize();

    }


}